import type { CompleteFieldSelector } from '@/types/fields-api.model';
import { Fixture } from '@/types/tournament.model';
import { MATCH_FIELDS } from '../match/match-fields.config';
import { TEAM_FIELDS } from '../team/team-fields.config';

const FIXTURE_FIELDS_FULL: CompleteFieldSelector<Fixture> = {
  status: true,
  groupList: {
    matchList: MATCH_FIELDS.FULL,
    teamList: {
      team: TEAM_FIELDS.FULL,
      stats: {
        matchesPlayed: true,
        wins: true,
        draws: true,
        losses: true,
        setsWon: true,
        setsLost: true,
        gamesWon: true,
        gamesLost: true,
        totalPoints: true,
      },
    },
  },
  knockoutTree: {
    rootNode: {
      match: MATCH_FIELDS.FULL,
      parent: true,
      leftChild: true,
      rightChild: true,
      round: true,
      advancingTeam: TEAM_FIELDS.FULL,
      roundName: false,
    },
  },
};

export const FIXTURE_FIELDS = {
  FULL: FIXTURE_FIELDS_FULL,
} as const;
